var existSettingsConfig = undefined
export const settingsConfig = () => {

  if (!existSettingsConfig) {
    const params = new URLSearchParams(window.location.search);
    const settings = window.serviceConfig?.settings[params.get("settings")];
    existSettingsConfig = {
      ...window.serviceConfig,
      ...settings
    }
  }

  return existSettingsConfig;
}

export const getRedColor = (t) => {
  t = Math.max(0, Math.min(1, t));
  return "rgba("
      + Number(200) + ", "
      + Number(0) + ", "
      + Number(0) + ", "
      + Number(0.2 + 0.8 * t)
      + ")";
}

export const getGreenColor = (t) => {
  t = Math.max(0, Math.min(1, t));
  return "rgba("
      + Number(40) + ", "
      + Number(200) + ", "
      + Number(40) + ", "
      + Number(0.2 + 0.8 * t)
      + ")";
}

export const getOrangeColor = (t) => {
  t = Math.max(0, Math.min(1, t));
  return "rgba("
      + Number(255) + ", "
      + Number(150) + ", "
      + Number(0) + ", "
      + Number(0.2 + 0.8 * t)
      + ")";
}

export const toDataGridRows = (data) => {
  if (!data)
    return;

  const columns = data.columns;

  var colNum = 0;
  const rows = data.rows.map((row, index) => {
    const item = { id: index };
    for (colNum = 0; colNum < columns.length; colNum++) {
      item[columns[colNum]] = row[colNum];
    }
    return item;
  })
  return rows;
}

export const toDataGridRows4crsrd = (data) => {
  if (!data)
    return;
  return data.map((item, index) => ({
    ...item,           // 기존 crsrdId, crsrdNm, lat, lng 그대로 복사
    id: index,         // DataGrid가 요구하는 숫자형 고유 ID (인덱스 사용)
  }));
}

export const toFormatedDateString = (d) => {
  function pad(n) { return n < 10 ? "0" + n : n }
  return d.getFullYear() + "년 " +
    pad(d.getMonth() + 1) + "월 " +
    pad(d.getDate()) + "일"
}

export const toFormatedDate = (d) => {
  function pad(n) { return n < 10 ? "0" + n : n }
  return d.getFullYear() + "-" +
    pad(d.getMonth() + 1) + "-" +
    pad(d.getDate()) + " " +
    pad(d.getHours()) + ":" +
    pad(d.getMinutes()) + ":" +
    pad(d.getSeconds())
}

export const toFormatedDateYYYYMMDDHHmm = (d) => {
  function pad(n) { return n < 10 ? "0" + n : n }
  return d.getFullYear() + "-" +
    pad(d.getMonth() + 1) + "-" +
    pad(d.getDate()) + " " +
    pad(d.getHours()) + ":" +
    pad(d.getMinutes())
}

export const toFormatedDateMMDDHHmm = (d) => {
  function pad(n) { return n < 10 ? "0" + n : n }
  return "" +
    pad(d.getMonth() + 1) + "-" +
    pad(d.getDate()) + " " +
    pad(d.getHours()) + ":" +
    pad(d.getMinutes())
}

export const toFormatedDateHHmmss = (d) => {
  function pad(n) { return n < 10 ? "0" + n : n }
  return "" +    
    pad(d.getHours()) + ":" +
    pad(d.getMinutes()) + ":" +
    pad(d.getSeconds())
}

export const toFormatedDateMinHour = (d) => {
  function pad(n) { return n < 10 ? "0" + n : n }
  return pad(d.getHours()) + "시" +
    pad(d.getMinutes()) + "분"
}

export const formatDistance = (distance) => {
  if (isNaN(distance)) {
    return "Invalid number";
  }

  if (distance >= 1000) {
    const km = (distance / 1000).toFixed(1);
    return km + " km";
  } else {
    return distance + " m";
  }
}

export const getViewport = () => {
  const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  return { width: viewportWidth, height: viewportHeight };
}

export const endsWithIgnoreCase = (str, suffix) => {
  return str.toLowerCase().endsWith(suffix.toLowerCase());
}

export const hexToRgba = (hex, opacity) => {
  hex = hex.replace('#', ''); // '#' 제거
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${opacity})`;
}

export const adjustAlpha = (colorString, alpha)=>  {
  let rgbaValues;

  if (colorString.startsWith('rgba(')) {
      rgbaValues = colorString.match(/[\d.]+/g);
      if (rgbaValues.length !== 4) {
          throw new Error('Invalid RGBA color string');
      }
  } else if (colorString.startsWith('rgb(')) {
      rgbaValues = colorString.match(/[\d]+/g) || [];
      if (rgbaValues.length !== 3) {
          throw new Error('Invalid RGB color string');
      }
      rgbaValues.push(1);
  } else {
      throw new Error('Invalid color string');
  }

  const [r, g, b] = rgbaValues.map(Number);
  const clampedAlpha = Math.min(1, Math.max(0, alpha));

  return `rgba(${r}, ${g}, ${b}, ${clampedAlpha})`;
}

export function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

export function getCookie(name) {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name + "=") === 0) {
      return cookie.substring(name.length + 1, cookie.length);
    }
  }
  return "";
}

export const getAbsoluteHost = (path, port) => {
  path = path.startsWith('/') ? path : `/${path}`
  return `${window.location.protocol}//${window.location.hostname}:${port ?? window.location.port}${path}`
}

export const getWebsocketHost = (path, port) => {
  path = path.startsWith('/') ? path : `/${path}`
  return `${window.location.protocol === "http:" ? "ws:" : "wss:"}//${window.location.hostname}:${port ?? window.location.port}${path}`
}

export const getSecondsToText = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const hoursText = hours > 0 ? `${hours}시` : '';
  const minutesText = minutes > 0 ? `${minutes}분` : '';
  const secondsText = remainingSeconds > 0 ? `${remainingSeconds}초` : '';

  if (hoursText && minutesText && secondsText) {
    return `${hoursText} ${minutesText} ${secondsText}`;
  } else if (hoursText && minutesText) {
    return `${hoursText} ${minutesText}`;
  } else if (hoursText && secondsText) {
    return `${hoursText} ${secondsText}`;
  } else if (minutesText && secondsText) {
    return `${minutesText} ${secondsText}`;
  } else if (hoursText) {
    return hoursText;
  } else if (minutesText) {
    return minutesText;
  } else {
    return secondsText;
  }
}

export const getSecondsToTextWithSec = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const hoursText = hours > 0 ? `${hours}시` : '';
  const minutesText = minutes > 0 ? `${minutes}분` : '';
  const secondsText = `${remainingSeconds}초`;

  if (hoursText && minutesText && secondsText) {
    return `${hoursText} ${minutesText} ${secondsText}`;
  } else if (hoursText && minutesText) {
    return `${hoursText} ${minutesText}`;
  } else if (hoursText && secondsText) {
    return `${hoursText} ${secondsText}`;
  } else if (minutesText && secondsText) {
    return `${minutesText} ${secondsText}`;
  } else if (hoursText) {
    return hoursText;
  } else if (minutesText) {
    return minutesText;
  } else {
    return secondsText;
  }
}

export const getDateStringToTimeText = (dateString) => {
  const date = new Date(dateString);
  return `${String(date.getHours()).padStart(2, "0")}시${String(date.getMinutes()).padStart(2, "0")}분`
}

export const getRandomIntInclusive = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// export const repeatEffect = (callback, sec, beforeCallback) => {
//   let timeoutKey = undefined
//   const loopCallback = async () => {    
//     await callback()

//     timeoutKey = setTimeout(async () => {
//       if (beforeCallback) {
//         const beforeSec = beforeCallback() ?? 1
//         timeoutKey = setTimeout(async () => {
//           await loopCallback()
//         }, 1000 * beforeSec)
//       } else {
//         await loopCallback()
//       }
//     }, 1000 * sec)
//   }

//   loopCallback();

//   return () => clearTimeout(timeoutKey)
// }
export const repeatEffect = (callback) => {
  let timeoutKey;

  const loopCallback = async () => {
    await callback();
    timeoutKey = setTimeout(loopCallback, 30000); 
  };

  loopCallback();

  return () => clearTimeout(timeoutKey);
};
export const repeatEffectVms = (callback) => {
  let timeoutKey;

  const loopCallback = async () => {
    await callback();
    timeoutKey = setTimeout(loopCallback, 10000); 
  };

  loopCallback();

  return () => clearTimeout(timeoutKey);
};

export const repeatEffectSeq = (callback, sec, beforeCallback) => {
  let timeoutKey = undefined
  let maxSeq = 0
  let curSeq = 0
  const loopCallback = async () => {       
    if(curSeq === maxSeq)
      curSeq = 0
    maxSeq = await callback(curSeq++)

    timeoutKey = setTimeout(async () => {
      if (beforeCallback) {
        const beforeSec = beforeCallback() ?? 1
        timeoutKey = setTimeout(async () => {
          await loopCallback()
        }, 1000 * beforeSec)
      } else {
        await loopCallback()
      }
    }, 1000 * sec)
  }

  loopCallback();

  return () => clearTimeout(timeoutKey)
}

export const changeDocumentTitleEffect = (title) => {
  const prevTitle = document.title
  document.title = title;
  return () => {
    document.title = prevTitle
  }
}